/** @format */

module.exports = {
  PLUGIN_NAME: 'FronthubWebpackPlugin',
  NAMESPACE: '__IF_YOU_USE_IT_THE_INCEPTION_TEAM_WILL_PUNISH_YOU__',
  CONTEXT: '__IT_IS_NOT_INTENDED_TO_BE_USED__',
  DEFAULT_FRONTHUB_FUNC_NAME: 'fronthub',
}
